import React from 'react'
import PropTypes from 'prop-types'
import FieldGroup from '../FieldGroup'

class ContactNumberInput extends React.Component {
  static propTypes = {
    validation: PropTypes.shape({
      isInvalid: PropTypes.bool.isRequired,
      message: PropTypes.string
    }).isRequired,
    setNumber: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string
  };

  constructor (props) {
    super(props)

    this.state = {
      touched: false
    }

    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
  if (this.props.value) {
    const validationResult = this.getvalidationstate(true, this.props.value)
    this.props.setNumber(validationResult, this.props.value)
  }
}

componentDidUpdate(prevProps) {
  if (this.props.value !== prevProps.value && this.props.value) {
    const validationResult = this.getvalidationstate(true, this.props.value)
    this.props.setNumber(validationResult, this.props.value)
  }
}

  handleFocus (event) {
    this.setState({ touched: true })
  }

  handleChange (event) {
    let touched = this.state.touched
    let value = event.target.value
    var validationResult = this.getvalidationstate(this.state.touched, value)
    this.props.setNumber(
      validationResult, value
    )
  }

  handleBlur (event) {
    let touched = this.state.touched
    let value = event.target.value
    var validationResult = this.getvalidationstate(this.state.touched, value)
    this.props.setNumber(validationResult, value)
  }

  getvalidationstate (touched, value) {
    if (!touched) {
      return {
        isInvalid: false,
        message: null,
        valid: false
      }
    }

    if (!value) {
      return {
        isInvalid: true,
        message: 'Please enter your contact number',
        valid: false
      }
    }

    if (!this.isNumeric(value)) {
      return {
        isInvalid: true,
        message: 'Contact number must contain only digits',
        valid: false
      }
    }

    if (value.length < 10) {
      return {
        isInvalid: true,
        message: 'Contact number is not long enough',
        valid: false
      }
    }

    if (value.length > 15) {
      return {
        isInvalid: true,
        message: 'Contact number length is too long (15)',
        valid: false
      }
    }

    return {
      isInvalid: false,
      message: null,
      valid: true
    }
  }

  isNumeric (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }

  render () {
    const { value, validation } = this.props
    const { isInvalid, message } = validation
    const handleChange = this.handleChange
    const handleBlur = this.handleBlur
    const handleFocus = this.handleFocus
    let label = this.props.label
    if (!this.props.label) {
      label = 'Contact number'
    }

    return <FieldGroup
      label={label}
      type='tel'
      required
      isInvalid={validation.isInvalid}
      value={value}
      onFocus={handleFocus}
      onBlur={handleBlur}
      message={message}
      onChange={handleChange} />
  }
}

export default ContactNumberInput
